import { nextDraftId } from "../../calculation/draftIdCounter";
import { isDTag } from "./editWorkUtil";

export function duplicateWorkObject(source, items, objects) {
  if (!source || source.system) return null;
  const clone = (value) => JSON.parse(JSON.stringify(value));
  const objectId = nextDraftId();
  const base = `${source.name || "Objektum"} – másolat`;
  let name = base, suffix = 2;
  while (objects.some((o) => o.name === name)) name = `${base} ${suffix++}`;
  const object = { ...clone(source), objectId, name, system: false, __isDraft: true };
  // Offset the copy so it is immediately distinguishable and can be moved in 3D.
  try {
    const position = JSON.parse(source.position || "[0,0,0]");
    if (Array.isArray(position) && position.length === 3 && position.every(Number.isFinite)) {
      object.position = JSON.stringify([position[0] + 100, position[1], position[2]]);
    }
  } catch (_) { /* Keep existing position format if it is not a vector. */ }
  const copiedItems = items.filter((it) => String(it.object?.objectId) === String(source.objectId)).map((it) => {
    const copy = { ...clone(it), itemId: nextDraftId(), __isDraft: true, object: { objectId }, work: clone(source.work) };
    delete copy.uid;
    delete copy.table; delete copy.createdTables; delete copy.CreatedTables;
    copy.tablePosition = null; copy.tableRotation = null;
    // Glued pairs within the copy remain paired, but not with the original object.
    const group = it.__duplungGroup || (isDTag(it.details) || String(it.details || "").startsWith("DU:") ? it.details : null);
    if (group) {
      copy.__duplungGroup = `DU:copy:${objectId}:${group}`;
      copy.details = copy.__duplungGroup;
    }
    return copy;
  });
  return { object, items: copiedItems };
}
